import { Button } from 'antd';

import { IContent } from '@/interfaces/lesson';
import { lessonsApi } from '@/services/lesson';
import { API_V4_BASE_URL } from '@/settings';
import styled, { StyledProp } from '@/styled';

import AudioPlayer from './Player';

const Audio = (props: IContent & StyledProp) => {
  const [downloadAudio] = lessonsApi.endpoints.downloadAudio.useLazyQuery();

  const reloadAudioFile = () => {
    downloadAudio(props.id);
  };

  const renderAudioContent = () => {
    if (!props.embed) {
      return (
        <div className='retryButton'>
          <Button type='ghost' onClick={reloadAudioFile}>
            Tentar novamente
          </Button>
          <span className='retryLabelError'>Não foi possível carregar o áudio.</span>
        </div>
      );
    }

    const url = `${props.embed.startsWith('http') ? '' : API_V4_BASE_URL}${props.embed}`;

    return (
      <div className='audio-container'>
        <AudioPlayer src={url} enabledDownload={!!props.download_enabled} />
      </div>
    );
  };

  return renderAudioContent();
};

export default styled(Audio)`
  .retryButton {
    margin: ${({ theme }) => theme.space.pxToRem(12)};
    padding: ${({ theme }) => theme.space.pxToRem(12)};
  }

  .retryLabelError {
    margin: ${({ theme }) => theme.space.pxToRem(12)};
  }
`;
